import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({});

class ActiveUserResultRow extends Component {
  render() {
    const { activeUser } = this.props;
    const startedDate = activeUser.Started.split(" ");
    const lastActivityDate = activeUser.LastActivity.split(" ");
    return (
      <TableRow>
        <TableCell padding="none">{activeUser.UserName}</TableCell>
        <TableCell padding="none">{activeUser.Skin}</TableCell>
        <TableCell padding="none">{activeUser.IpAddress}</TableCell>
        <TableCell padding="none">
          {startedDate[0]} <br />
          {startedDate[1]}
        </TableCell>
        <TableCell padding="none">
          {lastActivityDate[0]} <br />
          {lastActivityDate[1]}
        </TableCell>
      </TableRow>
    );
  }
}

ActiveUserResultRow.propTypes = {
  activeUser: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ActiveUserResultRow);
